import React from 'react';
import {observer} from 'mobx-react';
import {PriorityIcon, Button, Title} from '@priority-software/priority-style-react';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {formsStore} from '../../../_legacy/Form/stores/FormsStore';
import {getCurrentEntity} from '../../../_shared/GWTBridge/invoke/genPage';
import {createNewRow} from '../../../_shared/GWTBridge/invoke/headerPanel';
import {getIsEmptyTable} from '../../../_shared/GWTBridge/invoke/formTable';
import emptyStateTexts from './texts';
import emptyState from '../../../images/emptyState.png';
import emptyStateAdd from '../../../images/emptyStateAdd.svg';
import {PromotionBlock} from '../../../_legacy/Searches/components/AISearch/parts/PromotionBlock/PromotionBlock';

export const EmptyState = observer(() => {
    const {searchesStore} = formsStore;

    const title = searchesStore.formSelected
        ? emptyStateTexts.noResults
        : emptyStateTexts.noRecords;
    const message = searchesStore.formSelected
        ? emptyStateTexts.moreResultsMessage
        : renderNoRecordsToShow();
    const image = searchesStore.formSelected ? emptyState : emptyStateAdd;

    if (
        !searchesStore.emptyState ||
        !getCurrentEntity() ||
        (searchesStore.formSelected && !getIsEmptyTable())
    ) {
        return null;
    }

    return <EmptyStateComponent title={title} message={message} image={image} />;
});

function renderNoRecordsToShow() {
    return (
        <>
            <div>{emptyStateTexts.filterDataMessage}</div>
            <div>{emptyStateTexts.addNewMessage}</div>
            <Button prefixIcon={PriorityIcon.addSmall} onClick={createNewRow}>
                {getLocalizedText(texts.newTxt)}
            </Button>
        </>
    );
}

type size = 'small' | 'medium' | 'large';

interface EmptyStateProperties {
    image: string;
    title: string;
    children?: any;
    message: string | JSX.Element;
    size?: size;
}

export function EmptyStateComponent(props: EmptyStateProperties) {
    const {title, message, image} = props;
    return (
        <div className="empty-state-container">
            <div className="empty-state-align">
                <img src={image} alt="" />
                <Title skin="h2" textColor="primary-500">
                    {title}
                </Title>
                <div className="content">
                    {message}
                    <PromotionBlock />
                </div>
            </div>
        </div>
    );
}
